import React, { useState, useEffect, useCallback } from 'react';
import { ManagedImage } from './ManagedImage';

// Enkel, återanvändbar lightbox som matchar designen.
// Props: images = [{ url, alt }], startIndex, title, onClose
export const Lightbox = ({ images, startIndex = 0, onClose }) => {
  const [index, setIndex] = useState(startIndex);

  const hasMultiple = images.length > 1;

  const step = useCallback(
    (dir) => (e) => {
      if (e) e.stopPropagation();
      setIndex((i) => (i + dir + images.length) % images.length);
    },
    [images.length]
  );

  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowLeft') setIndex((i) => (i - 1 + images.length) % images.length);
      if (e.key === 'ArrowRight') setIndex((i) => (i + 1) % images.length);
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [images.length, onClose]);

  if (!images.length) return null;
  const current = images[index];

  return (
    <div
      onClick={onClose}
      className="fixed inset-0 z-[100] flex flex-col items-center justify-center gap-5"
      style={{ background: 'rgba(38,33,27,0.94)', padding: 'clamp(16px,4vw,40px)' }}
    >
      <div className="relative flex items-center justify-center w-full">
        {hasMultiple && (
          <button
            onClick={step(-1)}
            aria-label="Föregående"
            className="absolute z-[2] flex-shrink-0 w-13 h-13 rounded-full text-cv-base cursor-pointer flex items-center justify-center"
            style={{ left: 'clamp(4px,1.5vw,40px)', width: 52, height: 52, background: 'rgba(38,33,27,0.55)', border: '1px solid rgba(250,247,242,0.3)' }}
          >
            ←
          </button>
        )}
        <div onClick={(e) => e.stopPropagation()}>
          <ManagedImage
            url={current.url}
            basePath={current.basePath}
            filename={current.filename}
            alt={current.alt}
            fit="contain"
            style={{
              maxWidth: 'min(86vw, 900px)',
              maxHeight: '72vh',
              width: 'auto',
              height: 'auto',
              borderRadius: 'var(--cv-radius)',
              boxShadow: '0 32px 80px rgba(0,0,0,0.5)',
            }}
          />
        </div>
        {hasMultiple && (
          <button
            onClick={step(1)}
            aria-label="Nästa"
            className="absolute z-[2] flex-shrink-0 rounded-full text-cv-base cursor-pointer flex items-center justify-center"
            style={{ right: 'clamp(4px,1.5vw,40px)', width: 52, height: 52, background: 'rgba(38,33,27,0.55)', border: '1px solid rgba(250,247,242,0.3)' }}
          >
            →
          </button>
        )}
      </div>

      <div className="text-center flex flex-col gap-1.5">
        {current.alt && (
          <span className="font-serif text-[22px] text-cv-base">{current.alt}</span>
        )}
        {hasMultiple && (
          <span className="text-[13px] tracking-[0.2em] text-cv-faint">
            {index + 1} / {images.length}
          </span>
        )}
      </div>

      <button
        onClick={onClose}
        aria-label="Stäng"
        className="absolute bg-none border-none text-cv-base text-[28px] cursor-pointer leading-none"
        style={{ top: 20, right: 'clamp(14px,4vw,32px)', background: 'none', border: 'none' }}
      >
        ×
      </button>
    </div>
  );
};
